export const initialState = {};

export const initialResourceState = {
  list: [],
  detail: null,
};

export const getResourceState = (state, resource) => {
  const currentState =
    (state || initialState)[resource] || initialResourceState;
  return currentState;
};

export const getList = (state, resource) =>
  getResourceState(state || initialState, resource).list;

export const getDetail = (state, resource) =>
  getResourceState(state || initialState, resource).detail;

export const getUserProfile = (state, resource) =>
  getResourceState(state || initialState, resource).detail;
